type MutableState = Record<string, unknown>;

const deleteKey = (state: MutableState, key: string): void => {
    if (state && Object.prototype.hasOwnProperty.call(state, key)) {
        delete state[key];
    }
};

export const clearGarbageData = (state: MutableState = {}): void => {
    ['pageTitle', 'pageDescription', 'pageKeywords', 'mobile', 'footer'].forEach((key) => deleteKey(state, key));
};

export const clearGarbageAuthData = (state?: MutableState): void => {
    if (!state) return;
    deleteKey(state, 'auth');
};

export const clearGarbageDataForSendOrRequest = (state?: MutableState): void => {
    if (!state) return;
    clearGarbageData(state);
    ['browsers', 'languages', 'lang', 'jsMessages', 'messages', 'redirectTo', 'messageBodyMessages', 'authPromoAction', 'jsSettings'].forEach((key) =>
        deleteKey(state, key),
    );
    clearGarbageAuthData(state);
};

export const clearGarbageDataForReduxState = (state?: MutableState): void => {
    if (!state) return;
    clearGarbageData(state);
    [
        'browsers',
        'languages',
        'lang',
        'jsMessages',
        'messages',
        'redirectTo',
        'messageBodyMessages',
        'authPromoAction',
        'jsSettings',
        'form',
        'errors',
        'responseCode',
        'phone',
        'breadCrumb',
    ].forEach((key) => deleteKey(state, key));
    clearGarbageAuthData(state);
};
